<template>
  <section>
    <b-carousel
      v-model="carousel"
      :animated="animated"
      :has-drag="drag"
      :autoplay="autoPlay"
      :pause-hover="pauseHover"
      :pause-info="pauseInfo"
      :pause-info-type="pauseType"
      :interval="interval"
      :repeat="repeat"
    >
      <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
        <section :class="` is-medium is-bold`">
          <div class="has-text-centered">
             <p>{{carousel.text}}</p>
            <span class="image">
              <img :src="require(`@/assets/${carousel.image}`)" />
            </span> 
          </div>
        </section>
      </b-carousel-item>
    </b-carousel>
  </section>
</template>

<style scoped>
/* .carousel-item{
  width:100%;
  max-height: 200px !important;
} */
</style>

<script>
export default {
    data() {
        return {
            carousel: 0,
            animated: 'fade',
            drag: true,
            autoPlay: true,
            pauseHover: false,
            pauseInfo: false,
            repeat: true,
            pauseType: 'is-primary',
            interval: 7000,
            carousels: [
                { text: 'read&search – a standardized digital edition of your documents.', image: 'feature-1.png'},
                { text: 'Search your materials on basis of the full-text – either with or without Fuzzy search', image: 'feature-2.png' },
                { text: 'Modify your search using search facets – e.g. show only material containing your search term from a certain year, or document.', image: 'feature-3.png' },
                { text: 'View the page image and the recognised/transcribed text, or use the overlay to display the text.', image: 'feature-4.png' },
                { text: 'Make the connection to the Transkribus web-transcription interface for involving volunteers and crowd-users', image: 'feature-5.png' }            ]
        }
    },
    methods: {
        info(value) {
            this.carousel = value
            this.$buefy.toast.open({
                message: `This Slide ${value} !`,
                type: 'is-info'
            })
        }
    }
}
</script>
